import { render, staticRenderFns } from "./addAdvertisement.vue?vue&type=template&id=4158143a&scoped=true&lang=html"
import script from "./addAdvertisement.vue?vue&type=script&lang=js"
export * from "./addAdvertisement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4158143a",
  null
  
)

export default component.exports